export default [
  {
    path: '/admin/site/apply',
    name: 'ApplyList',
    component: () => import('@/views/site/apply/list/index'),
    meta: {
      title: '应用-我的应用',
      keepAlive: false,
      headType: 1,
      auth: true
    }
  },
  {
    path: '/admin/site/apply/add',
    name: 'AddApply',
    component: () => import('@/views/site/apply/list/edit'),
    meta: {
      title: '新增应用',
      keepAlive: false,
      headType: 1,
      auth: true
    }
  },
  {
    path: '/admin/site/apply/edit',
    name: 'EditApply',
    component: () => import('@/views/site/apply/list/edit'),
    meta: {
      title: '编辑应用',
      keepAlive: false,
      headType: 1,
      auth: true
    }
  },
  {
    path: '/admin/site/log_list',
    name: 'LogList',
    component: () => import('@/views/site/apply/log_list'),
    meta: {
      title: '操作日志',
      keepAlive: false,
      headType: 1,
      auth: true
    }
  }, {
    path: '/admin/site/station/system_update',
    name: 'SystemUpdate',
    component: () => import('@/views/site/station/system_update'),
    meta: {
      title: '站点-系统更新',
      keepAlive: false,
      headType: 1,
      auth: true
    }
  },
  {
    path: '/admin/site/station/storage',
    name: 'Storage',
    component: () => import('@/views/site/station/storage'),
    meta: {
      title: '站点-存储配置',
      keepAlive: false,
      headType: 1,
      auth: true
    }
  },
  {
    path: '/admin/site/station/station_setting',
    name: 'StationSetting',
    component: () => import('@/views/site/station/station_setting'),
    meta: {
      title: '站点-站点设置',
      keepAlive: false,
      headType: 1,
      auth: true
    }
  },
  {
    path: '/admin/site/employees_list',
    name: 'EmployeesList',
    component: () => import('@/views/site/power/employees_list'),
    meta: {
      title: '账号管理',
      keepAlive: false,
      headType: 1,
      auth: true
    }
  },
  {
    path: '/admin/site/plug_list',
    name: 'PlugList',
    component: () => import('@/views/site/plug/plug_list'),
    meta: {
      title: '插件列表',
      keepAlive: false,
      headType: 1,
      auth: true
    }
  },
  {
    path: '/admin/site/order_list',
    name: 'PrivateOrderList',
    component: () => import('@/views/site/plug/order_list'),
    meta: {
      title: '我的订单',
      keepAlive: false,
      headType: 1,
      auth: true
    }
  },
  {
    path: '/admin/site/plugin_details',
    name: 'PluginDetails',
    component: () => import('@/views/site/plug/plugin_details'),
    meta: {
      title: '插件详情',
      keepAlive: false,
      headType: 1,
      auth: true
    }
  },
  {
    path: '/admin/site/super/config',
    name: 'PrivateSuperConfig',
    component: () => import('@/views/site/super/config'),
    meta: {
      title: '账号设置',
      keepAlive: false,
      headType: 1,
      auth: true
    }
  },
  {
    path: '/admin/site/plug_package',
    name: 'PrivatePlugPackage',
    component: () => import('@/views/site/plug/plug_package'),
    meta: {
      title: '插件套餐',
      keepAlive: false,
      headType: 1,
      auth: true
    }
  },
  {
    path: '/admin/site/auth_info',
    name: 'PrivateAuthInfo',
    component: () => import('@/views/site/auth/auth_info'),
    meta: {
      title: '站点授权',
      keepAlive: false,
      headType: 1,
      auth: true
    }
  },
  {
    path: '/admin/site/station/sms_settings',
    name: 'SmsSettings',
    component: () => import('@/views/site/station/sms_settings'),
    meta: {
      title: '站点-短信设置',
      keepAlive: false,
      headType: 1,
      auth: true
    }
  },
  {
    path: '/admin/site/station/login_settings',
    name: 'LoginSettings',
    component: () => import('@/views/site/station/login_settings'),
    meta: {
      title: '站点-登录设置',
      keepAlive: false,
      headType: 1,
      auth: true
    }
  },
  {
    path: '/admin/site/plug_package_record',
    name: 'PrivatePlugPackageRecord',
    component: () => import('@/views/site/plug/plug_package_record'),
    meta: {
      title: '插件套餐记录',
      keepAlive: false,
      headType: 1,
      auth: true
    }
  },
  {
    path: '/admin/site/apply/plugin',
    name: 'PrivateApplyPlugin',
    component: () => import('@/views/site/apply/plugin'),
    meta: {
      title: '插件授权',
      keepAlive: false,
      headType: 1,
      auth: true
    }
  },
  {
    path: '/admin/site/apply/managers',
    name: 'ManagersApply',
    component: () => import('@/views/site/apply/managers'),
    meta: {
      title: '管理者',
      keepAlive: false,
      headType: 1,
      auth: true
    }
  }
]



// WEBPACK FOOTER //
// ./src/router/site.js